import { Card } from "@/components/ui/card";
import chilisLogo from "@/assets/clients/chilis.png";
import jollibee from "@/assets/clients/jollibee.png";
import sheratonLogo from "@/assets/clients/sheraton.png";
import mediamarktLogo from "@/assets/clients/mediamarkt.png";
import carrefourLogo from "@/assets/clients/carrefour.png";
import dunkinLogo from "@/assets/clients/dunkin.png";
import panasonicLogo from "@/assets/clients/panasonic.png";
import cocacolaLogo from "@/assets/clients/cocacola.png";
import marriottLogo from "@/assets/clients/marriott.png";
import pizzahutLogo from "@/assets/clients/pizzahut.png";
import shellLogo from "@/assets/clients/shell.png";
import quiktripLogo from "@/assets/clients/quiktrip.png";
import walmartLogo from "@/assets/clients/walmart.png";

const GlobalClients = () => {
  const clients = [
    { name: "Chili's", logo: chilisLogo },
    { name: "MediaMarkt", logo: mediamarktLogo },
    { name: "Carrefour", logo: carrefourLogo },
    { name: "Dunkin'", logo: dunkinLogo },
    { name: "Panasonic", logo: panasonicLogo },
    { name: "Coca-Cola", logo: cocacolaLogo },
    { name: "Jollibee", logo: jollibee },
    { name: "Marriott", logo: marriottLogo },
    { name: "Pizza Hut", logo: pizzahutLogo },
    { name: "Shell", logo: shellLogo },
    { name: "QuikTrip", logo: quiktripLogo },
    { name: "Walmart", logo: walmartLogo }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-background via-muted/20 to-background">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          PUDU Robotics <span className="text-primary">Global Brand Presence</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Brands and industries served by PUDU Robotics worldwide. Neil AI Global Solutions is an authorized PUDU robotics partner and AI automation provider.
        </p>
      </div>

      <div className="mb-12 px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {clients.map((client, idx) => (
            <Card
              key={idx}
              className="group bg-white border border-white/10 hover:border-primary/50 hover:shadow-[0_0_30px_hsl(var(--primary)/0.25)] transition-all duration-300 p-6 flex items-center justify-center min-h-[120px] rounded-xl"
            >
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                loading="lazy"
                className="max-w-[80%] max-h-16 w-auto h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </Card>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center max-w-5xl mx-auto">
        <Card className="glass-effect border-[hsl(var(--line))] p-5">
          <div className="text-3xl font-orbitron font-bold text-primary mb-1">120,000+</div>
          <p className="text-xs text-muted-foreground">Robots Shipped Globally</p>
        </Card>
        <Card className="glass-effect border-[hsl(var(--line))] p-5">
          <div className="text-3xl font-orbitron font-bold text-primary mb-1">80+</div>
          <p className="text-xs text-muted-foreground">Countries & Regions</p>
        </Card>
        <Card className="glass-effect border-[hsl(var(--line))] p-5">
          <div className="text-3xl font-orbitron font-bold text-primary mb-1">4</div>
          <p className="text-xs text-muted-foreground">Major Product Lines</p>
        </Card>
        <Card className="glass-effect border-[hsl(var(--line))] p-5">
          <div className="text-3xl font-orbitron font-bold text-primary mb-1">3</div>
          <p className="text-xs text-muted-foreground">R&D Centers Worldwide</p>
        </Card>
      </div>
      <p className="text-center text-xs text-muted-foreground mt-6 max-w-3xl mx-auto px-4">
        PUDU Robotics global company data. Neil AI Global Solutions is an authorized robotics partner and automation solutions provider.
      </p>
    </section>
  );
};

export default GlobalClients;
